module.exports = __webpack_public_path__ + "img/report.1bececef.png";